import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "children",
  "use": "children-usage",
  "viewBox": "0 0 27 24",
  "content": "<symbol viewBox=\"0 0 27 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"children\"><path d=\"M25.862 6.686h-3.694A.74.74 0 0 0 21.57 7l-2.416 3.4H0l1.08 4.486c.256.886 1.052 1.428 1.933 1.428h14.295c.91 0 1.705-.542 1.932-1.428l.512-2.172c.17-.714.88-1.914.966-2.057l1.79-2.514h3.297a.754.754 0 0 0 .74-.743c.056-.4-.285-.714-.683-.714zM14.608 22.514a1.849 1.849 0 0 1-1.847-1.857c0-1.028.824-1.857 1.847-1.857 1.023 0 1.847.829 1.847 1.857a1.849 1.849 0 0 1-1.847 1.857zm0-5.2a3.338 3.338 0 0 0-3.325 3.343A3.338 3.338 0 0 0 14.608 24a3.338 3.338 0 0 0 3.325-3.343 3.338 3.338 0 0 0-3.325-3.343zm-8.1 5.2a1.849 1.849 0 0 1-1.847-1.857c0-1.028.824-1.857 1.847-1.857 1.023 0 1.847.829 1.847 1.857a1.867 1.867 0 0 1-1.847 1.857zm0-5.2a3.338 3.338 0 0 0-3.325 3.343A3.32 3.32 0 0 0 6.508 24a3.32 3.32 0 0 0 3.325-3.343 3.338 3.338 0 0 0-3.325-3.343zM10.97 0L3.382 3.172.057 9.486h10.941V0h-.028z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/children.svg
// module id = 1540
// module chunks = 0